import { Path } from "react-native-svg";
import CustomIcon, { CustomIconProps } from "./CustomIcon";

const PurchaseHistory: React.FC<CustomIconProps> = (props) => (
  <CustomIcon {...props}>
    <Path clipRule="evenodd" d="M17 7.19995V15.6C17 15.9866 16.6866 16.3 16.3 16.3H3.7C3.3134 16.3 3 15.9866 3 15.6V6.49995H16.3C16.6866 6.49995 17 6.81336 17 7.19995ZM10.2899 5.09995H3V4.39995C3 4.01336 3.3134 3.69995 3.7 3.69995H8.88994L10.2899 5.09995Z" fillRule="evenodd" /> 
  </CustomIcon>
);

export default PurchaseHistory;